import { types } from 'mobx-state-tree'

export const GroupModel = types.model('Group').props({
  group_id: types.number,
  label: types.string,
  is_locked: types.boolean,
  method: types.string,
  tag_ids: types.array(types.number),
})
